// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-item[data-v-7b1ece86]{float:left}.card-item .head[data-v-7b1ece86]{color:#c8c8c8;font-size:14px;margin-bottom:13px;width:100%}.card-item .content[data-v-7b1ece86]{box-sizing:border-box;color:#181919;font-size:14px;font-weight:600;padding-right:10px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
